<template>

  <article class="c-article__form">
    <div class="u-8/10@tablet u-push-1/10@tablet" v-html="content.form"></div>
  </article>

</template>

<script>
import { getCookie } from '@/utils/cookies'

export default {
  name: 'Form',
  props: ['content'],

  mounted () {
    if (document.querySelector('.js-btn-form') !== null) document.querySelector('.js-btn-form').addEventListener('click', this.validateForm)
    this.$store.dispatch('addEventListeners')

    const form = document.querySelector('form')
    /* eslint-disable */
    eval(form.querySelectorAll('script')[1].innerHTML)
    /* eslint-enable */

    this.setDefaultValues()
  },

  methods: {
    setDefaultValues () {
      const inputClientType = document.getElementById('form-input-iAm')
      if (!inputClientType.length) {
        return
      }

      const splashOption = getCookie('splashOption')
      if (!splashOption) {
        return
      }

      inputClientType.value = this.$options.filters.capitalize(splashOption)
    },

    validateForm (e) {
      e.preventDefault()

      this.submitForm()
    },

    renderErrors (errors) {
      const errorFields = document.querySelectorAll('.c-form__group.has-error')
      for (let index = 0; index < errorFields.length; index++) {
        const element = errorFields[index]
        element.classList.remove('has-error')
        element.querySelector('.c-form__feedback').innerHTML = ''
      }

      for (var key in errors) {
        let input = document.querySelector(`*[name="${key}"]`)
        if (input === null) input = document.querySelector(`*[name="${key}[]"]`)

        input.closest('.c-form__group').classList.add('has-error')
        input.closest('.c-form__group').querySelector('.c-form__feedback').innerHTML = errors[key][0]
      }
    },

    submitForm () {
      const _this = this
      const form = document.querySelector('form')
      /**
       * FormData
       * Collect all the form data
       */
      var formData = new FormData(form)
      // for (var i = 0; i < form.elements.length; i++) {
      //   var key = form.elements[i].name
      //   var val = form.elements[i].value
      //   formData.append(key, val)

      //   if (val.length) {
      //     if (form.elements[i].type === 'checkbox') {
      //       formData.append(key, form.elements[i].checked)
      //     } else {
      //       formData.append(key, val)
      //     }
      //   }
      // }

      /**
       * AJAX form submit
       */
      const action = form.getAttribute('action')
      const request = new XMLHttpRequest()

      // Create the request
      request.open('POST', action, true)
      request.setRequestHeader('Accept', 'application/json')
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

      // Response
      request.onreadystatechange = function () {
        const requestResp = request.response
        console.log(requestResp)
        const response = JSON.parse(requestResp)
        if (request.readyState === 4 && request.status === 200 && response.success) {
          form.querySelector('.c-form__content').classList.add('u-hidden')
          form.querySelector('.c-form__message-success').classList.remove('u-hidden')
          form.querySelector('.c-form__message-error').classList.add('u-hidden')
          form.reset()
        } else {
          _this.renderErrors(response.errors)
          form.querySelector('.c-form__message-success').classList.add('u-hidden')
          form.querySelector('.c-form__message-error').classList.remove('u-hidden')
        }
      }

      // Send request
      request.send(formData)
    }
  }

}
</script>
